<template>
    <div class="category-accordion mb-3">
        <vue-collapsible-panel-group accordion>
            <vue-collapsible-panel :expanded="false">
                <template #title>
                    <span class="accordion-title">Kategorien</span>
                </template>
                <template #content>
                    <FilterItem
                        v-for="filter of filters"
                        :key="filter.title"
                        :icon="filter.icon"
                        :title="filter.title"
                        :name="filter.name"
                        :active="filter.active"
                        @toggleActive="toggleActive(filter)"
                    />
                </template>
            </vue-collapsible-panel>
        </vue-collapsible-panel-group>
    </div>
</template>

<script>
import {VueCollapsiblePanelGroup} from '@dafcoe/vue-collapsible-panel'
import {VueCollapsiblePanel} from '@dafcoe/vue-collapsible-panel'
import FilterItem from "@/views/components/ui/PublicMenuPlan/FilterItem";
import IconMenuFilter from "@/assets/images/filter_menu.svg?inline"
import IconSaladsFilter from "@/assets/images/filter_salad.svg?inline"
import IconOffersFilter from "@/assets/images/filter_offers.svg?inline"
import IconVeggieFilter from "@/assets/images/filter_veggie.svg?inline"
import IconVeganFilter from "@/assets/images/filter_vegan.svg?inline"
import IconFitMeFilter from "@/assets/images/filter_fitness.svg?inline"
import IconXXLFilter from "@/assets/images/filter_xxl.svg?inline"
import IconAllFilter from "@/assets/images/filter_all.svg?inline"
import {shallowRef} from 'vue'

export default {
    name: 'PublicMenuPlanFilter',
    components: {
        FilterItem,
        VueCollapsiblePanelGroup,
        VueCollapsiblePanel
    },
    props: ['initialFilter'],
    data() {
        return {
            filters: [
                {
                    title: 'Menüs',
                    name: 'Menüs',
                    icon: shallowRef(IconMenuFilter),
                    active: this.initialFilter.includes('Menüs'),
                },
                {
                    title: 'Salate & Co.',
                    name: 'Salate',
                    icon: shallowRef(IconSaladsFilter),
                    active: this.initialFilter.includes('Salate'),
                },
                {
                    title: 'Aktion',
                    name: 'Aktionen',
                    icon: shallowRef(IconOffersFilter),
                    active: this.initialFilter.includes('Aktionen'),
                },
                {
                    title: 'Veggie',
                    name: 'Veggie',
                    icon: shallowRef(IconVeggieFilter),
                    active: this.initialFilter.includes('Veggie'),
                },
                {
                    title: 'Vegan',
                    name: 'Vegan',
                    icon: shallowRef(IconVeganFilter),
                    active: this.initialFilter.includes('Vegan'),
                },
                {
                    title: 'FitMe',
                    name: 'FitMe',
                    icon: shallowRef(IconFitMeFilter),
                    active: this.initialFilter.includes('FitMe'),
                },
                {
                    title: 'XXL',
                    name: 'XXL',
                    icon: shallowRef(IconXXLFilter),
                    active: this.initialFilter.includes('XXL'),
                },
                {
                    title: 'Alles aus',
                    name: 'Alles',
                    icon: shallowRef(IconAllFilter),
                    active: this.initialFilter.includes('Alles'),
                }
            ],
        }
    },
    methods: {
        toggleActive(filter) {
            filter.active = !filter.active;

            switch (filter.name) {
                case 'Menüs':
                    if (filter.active) {
                        const saladFilter = this.filters.find((f) => f.name === 'Salate')
                        if (saladFilter) {
                            saladFilter.active = false
                        }
                    }
                    break
                case 'Salate':
                    if (filter.active) {
                        const menuFilter = this.filters.find((f) => f.name === 'Menüs')
                        if (menuFilter) {
                          menuFilter.active = false;
                        }
                    }
                    break
                case 'Alles':
                    if (filter.active) {
                        this.filters.forEach(f => f.active = false)
                    }
                    break
            }
            this.$emit('filterChanged', this.filters.filter(f => f.active).map(f => f.name));
        }
    },
    emits: ['filterChanged'],
}
</script>

<style lang="scss">
.category-accordion {
    .accordion-title {
        color: $primary;
        font-weight: $font-weight-black;
        font-size: $font-size-large;
    }

    .vcp--expandable {
        .vcp__header {
            padding: 15px 0;
        }

        .vcp__body-content {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
    }
}
</style>
